import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";



import lg_white_nb from './../media/img/lg_white_nb.png'
import lg_white from './../media/img/lg_white.jpg'
import lg_dark_nb from './../media/img/lg_dark_nb.png'
import lg_dark from './../media/img/lg_dark.jpg'
import bwog_logo from './../media/img/logo_nb.png'
import or1 from './../media/img/or1.jpg'
import or2 from './../media/img/or2.jpg'
import or3 from './../media/img/or3.jpg'
import or4 from './../media/img/or4.jpg'
import or5 from './../media/img/or5.jpg'
import or2_nb from './../media/img/or2_nb.png'

import tt1 from './../media/img/t1.jpg'
import tt2 from './../media/img/t2.jpg'
import tt3 from './../media/img/t3.jpg'
import tt4 from './../media/img/t4.jpg'
import tt5 from './../media/img/t5.jpg'

import riz1 from './../media/img/riz4.jpg'
import riz2 from './../media/img/riz5.jpg'
import riz3 from './../media/img/riz6.jpg'
import riz4 from './../media/img/riz7.jpg'
import riz1_v from './../media/img/riz1.mp4'
import riz2_v from './../media/img/riz2.mp4'
import riz3_v from './../media/img/riz3.mp4'

import x_logo from './../media/img/x-logo.png'
import tg_logo from './../media/img/tg-logo.png'
import dex_logo from './../media/img/dex-logo.png'
import phantom_logo from './../media/img/phantom_logo.png'
import sol_logo from './../media/img/sol_logo.png'
import bsc_logo from './../media/icons/bsc-icon.png'
import meta_logo from './../media/icons/meta-icon.png'

import ton_logo from './../media/img/tn-logo-bg.png'
import ton_keeper_logo from './../media/img/tonkeeper_logo.png'
import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import bm1 from './../media/img/bm1.jpg'
import bm2 from './../media/img/bm2.jpg'

import m1 from './../media/img/m1.jpg'
import m2 from './../media/img/m2.jpg'
import m3 from './../media/img/m3.jpg'
import m4 from './../media/img/m4.jpg'
import m5 from './../media/img/m5.jpg'
import m6 from './../media/img/m6.jpg'
import m7 from './../media/img/m7.jpg'

import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'

import com_icon from './../media/icons/com_icon.png'
import ama_icon from './../media/icons/ama_icon.png'
import inf_icon from './../media/icons/inf_icon.png'
import earn_icon from './../media/icons/earn_icon.png'
import check_icon from './../media/icons/check_icon.png'
import eq_icon from './../media/icons/eq_icon.png'
import lock_icon from './../media/icons/lock_icon.png'
import per_icon from './../media/icons/per_icon.png'

import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'


const Home = () => {


    const [htwCount, setHtwcount] = useState(0)



    return ( 
        <div className="">

            <section id="home" className="home">
                <div className="main-frame height_100_p">
                    <div className="flex row align-center hf-cont justify-center height_100_p">
                        <div className="home-text flex column justify-flex-end height_100_p">
                            {/* <img src={bwog_logo} className="home-text-logo-ant" alt="" data-aos="zoom-in" data-aos-duration="2000" /> */}
                            <div className="home-head-subhead" data-aos="fade-right" data-aos-duration="2000">
                                <h2>TURTLE UP | $TUP</h2>
                                <h3 className="text-align-center">UPgrade your mindset for success!</h3>
                                {/* <h3>Next Generation Gaming Platform That Offers a Whole New Experience in the World of Cryptocurrency.</h3> */}
                            </div>
                            <div className="flex row justify-center gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                <a href="https://x.com/TurtleUP_BSC" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={x_logo} alt="" />
                                </a>
                                <a href="https://t.me/turtleup" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={tg_logo} alt="" />
                                </a>
                                <a href="https://dexscreener.com/bsc/0x83a7e6745f9a704c4a0ebffcb37ac6b22f5aadc9?maker=0x5C4CF592527Ec92ae76755d741a35AB1ed301e0D" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={dex_logo} alt="" />
                                </a>
                            </div>
                            {/* <div className="flex row justify-center align-center gap-5 copy-address-box" data-aos="fade-up" data-aos-duration="2000">
                                <img src={copy_icon} alt="" />
                                <p>0x760539FF254A88B925fd940C8Bc01069cf76069b</p>
                            </div> */}
                            {/* <div className="flex row gap-15" data-aos="fade-up" data-aos-duration="2000">
                                <a href="" target="_blank" className='btn-1'>
                                    Buy Now
                                </a>
                                <a href="" target="_blank" className='btn-sp'>
                                    Join Community
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="htb" id="htb">
                <div className="htb-frame">
                    <div className="htb-header">
                        <h2>Trust the Turtle. The bull run is inevitable. 🔥📈</h2>
                        <h3>How to buy $TUP</h3>
                    </div>
                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={meta_logo} alt="" />
                                </div>
                                <h4>Metamask</h4>
                                <p>
                                    To swap $TUP on metamask,
                                </p>
                                <a href="metamask.io" target="_blank">Click here</a>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img className="htb-ton-logo" src={bsc_logo} alt="" />
                                </div>
                                <h4>Buy BNB</h4>
                                <p>
                                    Buy BNB from your metamask wallet or any centralized exchange of your choice. You can also get a friend to send you BNB
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={tt4} className="riz_img" alt="" />
                                </div>
                                <h4>Swap $TUP on DEX</h4>
                                <p>
                                    Now that you have an BNB in your wallet, you can now swap BNB to TUP 
                                    on <a href="https://pancakeswap.finance/swap?outputCurrency=0xef689d44188D7DFCc2dF8a3D8627d32dEf011D2C" target="_blank">pancakeswap</a> using 
                                    our Contract Address
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <seciton className="memes" id="memes">
                <div className="htb-frame">
                    <div className="cs-header">
                        <h2>WALL OF MEMES</h2>
                    </div>

                    <div className="wom-cont grid grid-column-3 grid-column-gap-20 grid-row-gap-20">
                        <div className="wom-item">
                            <img src={or1} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={or2} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={or3} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={or4} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={or5} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={or1} alt="" />
                        </div>
                    </div>
                </div>
            </seciton> */}

            <section className="about" id="about">
                <div className="htb-frame">
                    <div className="flex row wrap align-center">
                        <div className="about-text" data-aos="fade-right" data-aos-duration="2000">
                            <h3>Symbol of good luck and prosperity 🌙🚀</h3>
                            <p>
                                In many cultures and belief systems, the turtle is a symbol of good luck and prosperity. This is because they are peaceful and determined creatures.<br /><br />

                                $TUP - The cryptocurrency designed to reward his community<br />
                                TURTLE UP  offer you a fun and safe place to level up your cryptogame. A place where COMMUNITY makes sense, powered by a Winning Mindset. That's what it's all about.
                            </p>

                            <a href="https://x.com/TurtleUP_BSC" className="about-btn flex row gap-15 justify-center align-center">
                               <span>Check out Tweet</span> 
                               <img src={twitter_icon} alt="" />
                            </a>
                        </div>
                        <div className="about-img" data-aos="fade-left1" data-aos-duration="2000">
                            <img src={tt3} alt="" />
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="key-features">
                <div className="htb-frame">
                    <div className="cs-header">
                        <h2>WHY RIZZ?</h2>
                    </div>

                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={sol_logo} alt="" />
                                </div>
                                <h4>Solana Speed</h4>
                                <p>
                                    Faster than Brett’s lunch break.
                                </p>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <div className="kf-icon-box flex justify-center align-center">
                                        <img src={com_icon} className="" alt="" />
                                    </div>
                                </div>
                                <h4>Community Vibes</h4>
                                <p>
                                    Bears try to bring us down, but the Rizzler’s got moves they can’t handle. 🐻❌
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={riz2} className="riz_img" alt="" />
                                </div>
                                <h4>Moon Potential</h4>
                                <p>
                                    Pack your bags, Rizzlers—we’re moon-bound. 🚀
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section> */}

            <section className="tk" id="tk">
                <div className="htb-frame">
                    <div className="cs-header" data-aos="fade-up" data-aos-duration="2000">
                        {/* <h2>Uniting the Strengths of Floki and Shiba</h2> */}
                        <h2>TOKENOMICS</h2>
                    </div>
                    <div className="grid grid-column-4 row grid-column-gap-50 grid-row-gap-20" >

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={check_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Name/Ticker</h2>
                                <h3>$TUP</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={eq_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Total Supply</h2>
                                <h3>200 T</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={lock_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>LP Locked</h2>
                                <h3>Community is capable of adding liquidity</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={per_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Taxes</h2>
                                <h3>5/5</h3>
                                <h3>2 Marketing | 2 Development | 1 LP</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="roadmap" id="roadmap">
                <div className="main-frame">
                    <div className="roadmap-header" data-aos="fade-up" data-aos-duration="2000">
                        <h3>ROADMAP TURTLE TOKEN</h3>
                    </div>

                    <div className="roadmap-item-cont grid grid-column-3 grid-column-gap-25 grid-row-gap-10 overflow-y-hidden">
                        <div className="rd-item">
                            <h2>Phase 1: Launch</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Launch on pancakeswap</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Website Launch</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Lock and renounce 6 month</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Dexscreener update</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Trending</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Listings</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Callers</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Introduce Turtle Contests - Spin the wheel</span></p>
                            </div>
                        </div>

                        <div className="rd-item">
                            <h2>Phase 2: LFG</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>LOCKED - complete PHASE1</span></p>
                            </div>
                        </div>

                        <div className="rd-item">
                            <h2>Phase 3: stay tuned</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>LOCKED - complete PHASE2</span></p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="join" id="join">
                <div className="kf-frame">
                    <div className="cs-header overflow-y-hidden" data-aos="fade-up" data-aos-duration="2000">
                        <h2>Join Lucky moves, and Big Gains</h2>
                    </div>

                    <div className="join-box">
                        <div className="flex justify-center">
                            <img src={tt2} alt="" />
                        </div>
                        <p>
                            Turtle UP is more than just a memecoin—it’s a movement. Stay lucky, stay bullish, and be part of something epic. Together, 
                            we’re taking this to the moon with confidence, hype, and unstoppable energy. When the Turtle army is in control we only go UP 🚀💰
                        </p>
                        <h4>CA: 0xef689d44188D7DFCc2dF8a3D8627d32dEf011D2C</h4>
                        <a href="https://t.me/turtleup" target="_blank" className="btn-1">Telegram</a>
                    </div>
                </div>
            </section>

            <section className="footer" id="footer">
                <div className="main-container">
                    
                        <div className="footer-box ">
                            <h2>TURTLE UP</h2>
                            <div className="flex justify-center">
                                <div className="flex row gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                    <a href="https://x.com/TurtleUP_BSC" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={x_logo} alt="" />
                                    </a>
                                    <a href="https://t.me/turtleup" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tg_logo} alt="" />
                                    </a>
                                    {/* <a href="mailto:dhurovcoin@gmail.com" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={mail_icon} alt="" />
                                    </a> */}
                                    <a href="https://dexscreener.com/bsc/0x83a7e6745f9a704c4a0ebffcb37ac6b22f5aadc9?maker=0x5C4CF592527Ec92ae76755d741a35AB1ed301e0D" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={dex_logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <p className="copyright">TURTLE UP copyright 2024 - All Rights Reserved</p>
                    </div>

                    {/* <hr /> */}
                </div>
            </section>

        </div>
    );
}
 
export default Home;